module.exports = {
  // Key is ISO-3166 Alpha-2 Code, kennung is internal code
  DE: { api: 'DE', kennung: 'D', human: 'Deutschland' }
}
